import { useCanGoBack, useNavigate, useRouter } from '@tanstack/react-router'
import { XIcon } from 'lucide-react'

import { Button } from '@/components/ui'
import { getProjectPath } from '@/utils'

export function CloseButton({ slug }: { slug: string }) {
  const router = useRouter()
  const canGoBack = useCanGoBack()
  const navigate = useNavigate()

  // A Workbench opened straight from a pasted link has no page to go back to.
  const close = () =>
    canGoBack
      ? router.history.back()
      : navigate({ to: getProjectPath({ slug }) })

  return (
    <Button theme="ghost" size="sm" isIcon title="Close" onClick={close}>
      <XIcon className="size-4" />
      <span className="sr-only">Close</span>
    </Button>
  )
}
